export default __webpack_public_path__ + "static/15-7102cceeb98fada7bdb8fdf043b339ef.jpg";